import React from 'react';
import styled from 'styled-components';

const StyledSvgLink = styled.a`
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
        color: rgba(255, 255, 255, 1);
    }
`;

const SvgLink = ({ href }) => {
    return (
        <StyledSvgLink href={href}>
            <svg viewBox="0 0 16 16" width="20" height="20">
                <path d="M13.58 7.37334L8.44662 12.5067C7.64159 13.3279 6.56645 13.83 5.41995 13.92H5.12662C4.129 13.9315 3.16844 13.5424 2.45995 12.84C0.899951 11.28 1.05328 8.58667 2.79995 6.84L7.39995 2.24C7.65998 1.98152 8.07993 1.98152 8.33995 2.24C8.46616 2.36518 8.53715 2.53558 8.53715 2.71334C8.53715 2.8911 8.46616 3.06149 8.33995 3.18667L3.73328 7.79334C2.49995 9.02 2.34662 10.8667 3.38662 11.9067C3.9063 12.3992 4.61394 12.6424 5.32662 12.5733C6.15126 12.5048 6.92323 12.1401 7.49995 11.5467L12.6666 6.43334C13.4403 5.77611 13.5469 4.62109 12.9066 3.83334C12.121 3.19381 10.9682 3.30051 10.3133 4.07334L5.17995 9.20667C5.01212 9.36956 4.90807 9.58711 4.88662 9.82C4.86791 9.99041 4.92382 10.1606 5.03995 10.2867C5.37939 10.5316 5.85028 10.4735 6.11995 10.1533L11.5266 4.74667C11.7866 4.48819 12.2066 4.48819 12.4666 4.74667C12.5928 4.87185 12.6638 5.04225 12.6638 5.22C12.6638 5.39776 12.5928 5.56816 12.4666 5.69334L7.06662 11.0933C6.28439 11.9477 4.95916 12.0102 4.09995 11.2333C3.32135 10.3759 3.3809 9.05078 4.23328 8.26667L9.33328 3.13334C10.5101 1.83679 12.5115 1.72973 13.82 2.89334C14.9828 4.19954 14.8757 6.19885 13.58 7.37334Z" fill="currentColor"></path>
            </svg>
        </StyledSvgLink>
    );
};

export default SvgLink;

